import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
declare var $: any;
@Component({
  selector: 'app-cookies-policy',
  templateUrl: './cookies-policy.component.html',
  styleUrls: ['./cookies-policy.component.sass']
})
export class CookiesPolicyComponent implements OnInit {

  constructor(private readonly _router: Router) { }

  ngOnInit(): void {
  }

  saveCookies():void {
    localStorage.setItem('cookies','cookies')
    this._router.navigate([`/`]);
  }

}
